import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest();

export const login = async (data: { username: string; password: string }) => {
  const res = await httpRequest.post('/api/auth/login', data);
  return res;
};

export const otp = async (data: { username: string }) => {
  const res = await httpRequest.get('/api/otp/get', data);
  return res;
};

export const forgot = async (data: { username: string }) => {
  const res = await httpRequest.put('/api/auth/forgot', data);
  return res;
};

export const password = async (data: { username: string; password: string }) => {
  const res = await httpRequest.put('/api/auth/password', data);
  return res;
};

export const verify = async (data: { username: string; code: string }) => {
  const res = await httpRequest.put('/api/otp/verify', data);
  return res;
};
